<template>
  <v-container>
    <h2 style="font-size:18px;">{{$t('Setting')}}</h2>
    <v-card style="background-color:#F4B95F;">
      <v-card-text style="padding:10px;">
        <v-container grid-list-md style="padding-top:0px;padding-bottom:0px;">
          <v-layout wrap>
            <v-flex xs12>
              <h4 class="inputTitle">{{$t('ChatAccountToken')}} :</h4>
              <input
                v-model="chatAccToken"
                class="form-control"
                name="chatAccToken"
                required
                autocomplete="nope"
                type="text"
                @input="chatAccToken = $event.target.value"
              />
            </v-flex>
            <span v-if="chatAccTokenError != ''" class="txtClrRed">{{$t(chatAccTokenError)}}</span>
            <v-flex xs12>
              <h4 class="inputTitle">{{$t('SenderToken')}} :</h4>
              <input
                v-model="userAccToken"
                class="form-control"
                required
                autocomplete="nope"
                type="text"
                name="userAccToken"
                @input="userAccToken = $event.target.value"
              />
            </v-flex>
            <span v-if="userAccTokenError != ''" class="txtClrRed">{{$t(userAccTokenError)}}</span>
          </v-layout>
        </v-container>
        <span
          v-if="settingError != ''"
          style="padding-left:16px;"
          class="txtClrRed"
        >{{settingError}}</span>
      </v-card-text>
    </v-card>

    <v-btn style="float:right;" color="primary" @click="checkInputToken()">{{$t('Save')}}</v-btn>

    <v-layout class="text-xs-center">
      <v-dialog v-model="loadingDialog" persistent width="1000">
        <v-card height="200">
          <v-card-text>
            <br />
            <!-- <v-btn color="primary" style="float:right;" @click="closeLoadingDialog()">X</v-btn> -->
            <v-layout row wrap align-center>
              <v-progress-circular
                :size="100"
                :width="8"
                color="primary"
                indeterminate
                class="progress-circular"
              ></v-progress-circular>
            </v-layout>
            <div>
              <h3 class="loadingMsg">{{$t('InProgressPleaseWaitAMoment')}}</h3>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="recordSaveDialog" persistent width="300">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            color="primary-title"
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text style="padding-top:5px;padding-bottom:0px;">
            <h2 style="margin:0px;">{{$t('RecordSuccessfullySaved')}}</h2>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" flat @click="recordSaveDialog = false">{{$t('Ok')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-container>
</template>

<script>
import JS from './JsonService'
import { translateErrorMsg } from './translateErrorMsg'
import VersionDialog from '../src/VersionNotMatchDialog'
export default {
  components: {
    VersionDialog
  },
  mixins: [translateErrorMsg],
  data() {
    return {
      chatAccToken: '',
      userAccToken: '',
      settingError: '',
      chatAccTokenError: '',
      userAccTokenError: '',
      loadingDialog: false,
      recordSaveDialog: false,
      versionError: false
    }
  },
  created: function() {
    this.getSetting()
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    getSetting() {
      this.loadingDialog = true
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      var version = sessionStorage.getItem('version')
      const url = 'Back/GetKtnConfig'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: userInfo.KtnID
      }
      //console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            this.loadingDialog = false
            this.settingError = ''
            this.chatAccToken = response.data.jx
            this.userAccToken = response.data.bp
          }
        })
        .catch(error => {
          console.log(error)
          this.settingError = error
          this.versionError = false
          this.loadingDialog = false
        })
    },
    checkInputToken() {
      this.loadingDialog = true
      this.chatAccToken = this.chatAccToken.trim()
      this.userAccToken = this.userAccToken.trim()
      if (this.chatAccToken == '' && this.userAccToken == '') {
        this.chatAccTokenError = ''
        this.userAccTokenError = ''
        this.saveSetting()
      } else if (this.chatAccToken != '' && this.userAccToken != '') {
        this.chatAccTokenError = ''
        this.userAccTokenError = ''
        this.saveSetting()
      } else {
        if (this.chatAccToken != '' && this.userAccToken == '') {
          this.chatAccTokenError = ''
          this.userAccTokenError = translateErrorMsg.translateMsg(
            'Sender Token Cannot Be Empty'
          )
          this.loadingDialog = false
        } else if (this.chatAccToken == '' && this.userAccToken != '') {
          this.userAccTokenError = ''
          this.chatAccTokenError = translateErrorMsg.translateMsg(
            'Chat Account Token Cannot Be Empty'
          )
          this.loadingDialog = false
        }
      }
    },
    saveSetting() {
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      var version = sessionStorage.getItem('version')
      const url = 'Back/EditKtnConfig'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: userInfo.KtnID,
        jx: this.chatAccToken,
        bp: this.userAccToken
      }
      //console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ht) {
              this.loadingDialog = false
              this.settingError = ''
              this.recordSaveDialog = true
            } else {
              this.loadingDialog = false
              this.settingError = response.data
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.loadingDialog = false
          this.versionError = false
          this.settingError = error
        })
    }
  }
}
</script>

<style>
.inputTitle {
  font-size: 14px;
}
</style>
